import { useQuery } from '@apollo/client';
import { gql } from '@apollo/client';

const GET_BILLING_STATS = gql`
  query GetBillingStats {
    getBillingStats {
      totalUsers
      trialUsers
      activeUsers
      frozenUsers
      expiredTrials
    }
  }
`;

export interface BillingStats {
  totalUsers: number;
  trialUsers: number;
  activeUsers: number;
  frozenUsers: number;
  expiredTrials: number;
}

export const useBillingStats = () => {
  const { data, loading, error, refetch } = useQuery<{
    getBillingStats: BillingStats;
  }>(GET_BILLING_STATS, {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  return {
    billingStats: data?.getBillingStats,
    loading,
    error,
    refetch,
  };
};
